import { get, postForm } from './http';

export const getAuthorize = clientId => get('/system/oauth2/authorize', { clientId });

export const authorize = ({ responseType, clientId, redirectUri, state, autoApprove, checkedScopes, uncheckedScopes }) => {
  const scopes = {};
  checkedScopes.forEach(scope => {
    scopes[scope] = true;
  });
  uncheckedScopes.forEach(scope => {
    scopes[scope] = false;
  });

  return postForm('/system/oauth2/authorize', {
    response_type: responseType,
    client_id: clientId,
    redirect_uri: redirectUri,
    state,
    auto_approve: autoApprove,
    scope: JSON.stringify(scopes)
  });
};
